import React from 'react'
import cx from 'classnames'

import { TComponentBase } from '../../types/componentBase'

type TRowProps = {
  hasGutter?: boolean
  as?: React.ElementType
  ref?: React.Ref<HTMLElement>
}

const Row = React.forwardRef<HTMLElement, TRowProps & TComponentBase>((props, ref) => {
  const className = cx('flex flex-wrap', { '-mx-8 sm:-mx-12 md:-mx-16 lg:-mx-24': props.hasGutter }, props.className)
  const Element = props.as || 'div'
  return (
    <Element className={className} style={props.style} ref={ref} onClick={props.onClick}>
      {React.Children.map(props.children, (element) => {
        if (React.isValidElement(element)) {
          return React.cloneElement(element, {
            // only forward `hasGutter` when child is a component otherwise React would complain that a DOM element cannot have an attribute of 'hasGutter'
            ...(typeof element.type !== 'string' ? { hasGutter: props.hasGutter } : {}),
          })
        }
        return element
      })}
    </Element>
  )
})

Row.displayName = 'Grid.Row'

export { Row as default, TRowProps }
